import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
const items = ['Quieres crear tu primer producto digital', 'No sabes por dónde empezar', 'No quieres aparecer en cámara', 'Quieres generar ingresos desde casa', 'Tienes poco tiempo al día', 'Quieres usar la IA para trabajar menos'];
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    x: -20
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.4
    }
  }
};
export function WhoItsFor() {
  return <section className="w-full bg-navy px-4 py-16 md:py-24" data-id="element-92">
      <div className="max-w-3xl mx-auto" data-id="element-93">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="font-oswald text-3xl md:text-4xl font-bold text-white text-center uppercase mb-12" data-id="element-94">
          Esta clase es <span className="text-red" data-id="element-95">para ti</span> si:
        </motion.h2>

        <motion.ul variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="space-y-5 max-w-lg mx-auto" data-id="element-96">
          {items.map(item => <motion.li key={item} variants={itemVariants} className="flex items-start gap-4" data-id="element-97">
              <CheckCircleIcon className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" data-id="element-98" />
              <span className="text-white font-inter text-base md:text-lg leading-relaxed" data-id="element-99">
                {item}
              </span>
            </motion.li>)}
        </motion.ul>
      </div>
    </section>;
}